const uuidRegex = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
let sStoragePlugin = 'LocalStorage'; // default first party localStorage
const sThirdPartyCookiesEnabled = ''; // default
let resolveThirdpartyCookieCheck = '';
let removeProps = [];
let publicConfig = {};

// Permissions: Update this for any new plugins that need access to LocalStorage plugin, NewRelic plugin
export const ALLOWED_PLUGINS = [
  'Auth',
  'Conversations',
  'CobrowseService',
  'Cobrowse',
  'VideoHelper',
  'Cookies',
  'Engage',
  'Genesys',
  'GenesysJS',
  'Home',
  'Identifiers',
  'Journey',
  'Knowledge',
  'KnowledgeService',
  'Launcher',
  'LocalStorageTest',
  'MessagingService',
  'MessagingMiddleware',
  'Messenger',
  'NewRelic',
  'SubMessenger',
  'SupportCenter',
  'Toaster',
  'LocalStorage',
];

// A list of keys that require to be prefixed by deploymentId when stored in browser's local storage
export const DEPLOYMENT_PREFIXED_KEYS = ['actmu', 'actms', 'actts', 'actvc', 'actmr', 'actec', 'actsc', 'gcatkn', 'gcartkn', 'gcagttype', 'vd:offerSt'];

const IFRAME_PERMITTED_ALLOW_ATTR_VALUES = ['camera', 'microphone', 'display-capture'];

// ---- No 3rd party domain storage initialization for GA ------ //

// function onThirdPartyPostMessage(evt) {
//   if (evt.data === 'ThirdpartyStorageUnsupported') {
//     sThirdPartyCookiesEnabled = 'false';
//     console.log('%c 3rd Party storage disabled!', 'color: red; font-weight: bold;');
//     if (resolveThirdpartyCookieCheck) {
//       resolveThirdpartyCookieCheck(sThirdPartyCookiesEnabled);
//       resolveThirdpartyCookieCheck = ''; //reset
//     }
//   } else if (evt.data === 'ThirdpartyStorageSupported') {
//     sThirdPartyCookiesEnabled = 'true';
//     console.log('%c 3rd Party storage enabled!', 'color: green; font-weight: bold;');
//     if (resolveThirdpartyCookieCheck) {
//       resolveThirdpartyCookieCheck(sThirdPartyCookiesEnabled);
//       resolveThirdpartyCookieCheck = ''; //reset
//     }
//   }
// }

// window.addEventListener('message', onThirdPartyPostMessage, false);

// const iframe = document.createElement('iframe');

// iframe.style.display = 'none';
// iframe.src = 'https://apps.inindca.com/messenger/dev/verifycookie.html';
// document.body.appendChild(iframe);

function removeObjectProps(config, path) {
  return Object.keys(config).reduce((object, key) => {
    // don't include properties when its found in the list
    let skip = !(removeProps.indexOf(key) === -1);

    if (path) {
      // skip if removal properties are found in the path
      skip = !(removeProps.indexOf(`${path}.${key}`) === -1);
    }

    // when it is array, include it as-is for now. This may change tomorrow.
    if (!skip && Array.isArray(config[key])) {
      object[key] = config[key];
    } else if (path && !skip) {
      // check if its not an object and include it if its not in the skip list
      if (typeof config[key] !== 'object') {
        object[key] = config[key];
      } else {
        // if it is an nested object, iterate through its properties
        object[key] = removeObjectProps(config[key], `${path}.${key}`);
      }
    } else if (!skip && typeof config[key] !== 'object' && removeProps.indexOf(key) === -1) {
      // check if its not an object and include it if its not in the skip list
      object[key] = config[key];
    } else if (!skip && typeof config[key] === 'object') {
      // if it is an nested object, iterate through its properties
      object[key] = removeObjectProps(config[key], key);
    }

    return object;
  }, {});
}

export function isNil(object) {
  return object === null || object === undefined;
}

export function isValidUuid(uuid) {
  return typeof uuid === 'string' && uuidRegex.test(uuid);
}

export function clone(obj) {
  return Object.assign({}, obj);
}

/**
 * Clone object containing only string data in the object properties
 * @param {*} obj
 */
export function sanitizeObject(obj) {
  const cloneObj = {};

  for (const i in obj) {
    if (i && typeof obj[`${i}`] === 'object' && obj[`${i}`] !== null) // using string literal to safely parse the keys in an object - Fix codacy "Generic Object Injection Sink"
      cloneObj[`${i}`] = sanitizeObject(obj[`${i}`]);
    else if (i && typeof obj[`${i}`] === 'string')
      cloneObj[`${i}`] = obj[`${i}`];
    else
      return; // to avoid continue executing the function endlessly
  }

  return cloneObj;
}

/**
 * Transform our deploymentConfig to public config trimming unwanted properties. This is especially used by brands in Headless mode to build their own UI.
 */
export function setPublicConfig(deploymentConfig, removeConfigProps) {
  const setPromise = new Promise((resolve) => {
    removeProps = removeConfigProps;
    publicConfig = removeObjectProps(deploymentConfig);
    resolve(publicConfig);
  });

  return setPromise;
}

export function getPublicConfig() {
  return publicConfig;
}

export function isValidURL(string) {
  try {
    new URL(string);

    return true;
  } catch (error) {
    return false;
  }
}

export function isThirdPartyStorageEnabled() {
  const thirdPartyCheckPromise = new Promise((resolve)=>{
    // Check if 3rd party cookies are enabled. If yes, return "CrossDomainLocalStorage" else "LocalStorage"

    if (!sThirdPartyCookiesEnabled) {
      resolveThirdpartyCookieCheck = resolve;
    } else {
      resolveThirdpartyCookieCheck = '';  // eslint-disable-line

      resolve(sThirdPartyCookiesEnabled); // resolve with the value
    }
  });

  return thirdPartyCheckPromise;
}

/**
 * To allow switching between localstorage, crossDomainStorage and cookies.
 */
export function getStoragePlugin() {
  const devConfig = localStorage.getItem('genesysjs');  // eslint-disable-line

  if (devConfig) {
    let oDevConfig = {};

    try {
      oDevConfig = JSON.parse(devConfig);
    } catch (e) {
      console.warn('Error parsing JSON', e);
    }

    const { cookies } = oDevConfig;

    /** For future: extend here when cross domain localStorage is agreed as an option */

    if (cookies) sStoragePlugin = 'Cookies';
  }

  return sStoragePlugin;
}

/**
 * function that converts iframe HTML string to parsable HTML DOM.
 * @param {string} str
 */
export function stringToHTML(str) {
  // If DOMParser is supported, use it
  const support = (() => {
    if (!window.DOMParser) return false;
    const parser = new DOMParser();

    try {
      /** The provided string is verified as required for the product. False positive on security scan */
      parser.parseFromString('x', 'text/html'); // eslint-disable-line
    } catch (err) {
      return false;
    }

    return true;
  })();

  if (support) {
    const parser = new DOMParser();
    /** The provided string is verified as required for the product. False positive on security scan */
    const doc = parser.parseFromString(str, 'text/html'); // eslint-disable-line

    return doc.body.firstChild; // Append to the existing body tag of parent page
  }
  // Otherwise, fallback to old-school method
  const dom = document.createElement('div');

  /** The provided string is verified as required for the product. False positive on security scan */
  dom.innerHTML = str; // eslint-disable-line

  return dom;
}

/**
 * function that filters iframe allow attribute values to only include permitted ones.
 * @param {string} allowString - The allow attribute string (e.g. "camera; microphone; geolocation")
 * @returns Filtered string with only permitted values (e.g. "camera; microphone") or empty string if none found
 */
export function filterIframeAllowAttribute(allowString) {
  return allowString
    .split(';')
    .map(feature => feature.trim())
    .filter(feature => IFRAME_PERMITTED_ALLOW_ATTR_VALUES.includes(feature))
    .join('; ');
}

/**
 * function that can shallow or deep merge given 2 objects
 * @param  {boolean} true - deep merge, false - shallow merge
 * @param  {obj1, ob2, ...} objects to merge
 */
export function merge(...args) {
  // Variables
  const target = {};
  let deep = false;
  let i = 0;

  // Check if a deep merge
  if (typeof args[0] === 'boolean') {
    deep = args[0];
    i++;
  }

  // Merge the object into the target object
  const merger = (obj) => {
    for (const prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        if (deep && Object.prototype.toString.call(obj[`${prop}`]) === '[object Object]') {
          // If we're doing a deep merge and the property is an object
          if (Object.prototype.toString.call(target[`${prop}`]) === '[object Object]') {
            target[`${prop}`] = merge(true, target[`${prop}`], obj[`${prop}`]);
          } else target[`${prop}`] = merge(target[`${prop}`], obj[`${prop}`]);
        } else {
          // Otherwise, do a regular merge
          target[prop] = obj[prop];
        }
      }
    }
  };

  //Loop through each object and conduct a merge
  for (; i < args.length; i++) {
    merger(args[i]);
  }

  return target;
}

/**
 * A function that accepts object, filters and returns only properties removing any methods that it may contain.
 * @param {object} obj
 */
export function cloneObjectPropsOnly(obj) {
  const newObj = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key) && typeof obj[key] !== 'function') {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}

/**
 * function that checks if it is firefox browser and return boolean
 */
export function isFireFox() {
  const uA = navigator.userAgent.match(/Firefox[/\s](\d+\.\d+)/);

  return Array.isArray(uA) && uA.length >= 2;
}

/**
 * WEBMESS-289, WEBMESS-1579: [accessibility] - to check whether it is an iphone device and apply the aria properties only on them
 * to avoid background page navigation while using with screen readers
 **/
export function isIphone() {
  const bIphone = /iP(hone|od)/i.test(window.navigator.userAgent);

  if (bIphone)
    return true;
  else
    return false;
}
